import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {createReducer, on} from '@ngrx/store';
import {ICookiePolicyState} from '../models/cookie-policy-state.model';
import {hideCookieConsent, showCookieConsent} from './cookie-policy.actions';

const initialState: ICookiePolicyState = {
  status: EActionStatus.Initial,
  showConsentDialog: false,
};
export const cookiePolicyReducer = createReducer(
  initialState,
  on(showCookieConsent, state => ({
    ...state,
    status: EActionStatus.Success,
    showConsentDialog: true,
  })),
  on(hideCookieConsent, state => ({
    ...state,
    status: EActionStatus.Success,
    showConsentDialog: false,
  }))
);
